import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface IGeneralHealth {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  veryGoodHealth?: number | null;
  goodHealth?: number | null;
  fairHealth?: number | null;
  badHealth?: number | null;
  veryBadHealth?: number | null;
}

export const defaultValue: Readonly<IGeneralHealth> = {};
